<template>
  <picture>
    <source :srcset="large" media="(min-width:500px) and (max-width:768px)">
    <source :srcset="large" media="(min-width:280px) and (max-width:479px)">
    <img :src="medium" :alt="altText" />
  </picture>
</template>

<script>
  export default {
    name: "base-picture",
    props:{
      missing:{
        type:String,
        required:true,
      },
      large:{
        //400x400
        type:String,
        required:false,
        default:null
      },
      medium:{
        //200x200
        type:String,
        required:false,
        default:null
      },
      thumb:{
        //120x120
        type:String,
        required:true,
      },
      mini:{
        //60x60
        type:String,
        required:false,
        default:null
      },
      altText:{
        type:String,
        required:true,
      }
    },
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/base/_base-picture.vue